import { PlanningConstantsPanel } from "@/components/admin/PlanningConstantsPanel";

export function SettingsPlanningPage() {
  return <PlanningConstantsPanel />;
}
